/**
 * 로그인 (옛 화면 signup/login — 머큐리·구 악덕알리미 앱이 /m/login · /b/v1/login 으로 연다)
 * 비밀번호 보기·입력칸 아이콘·아이디 하이픈·jquery-validation 검증·제출
 * ($j.Pages.Mobile.Login / body data-page-name="Login")
 */
export default class Login {
    initialize() {
        // 다른 기기에 자리를 내주고 밀려나 왔다 (DeviceSlotService::kickOut) — #page-data
        const kicked = JSON.parse(document.getElementById('page-data')?.textContent || '{}').kickedNotice;
        if (kicked) $j.Common.Util.swalert(kicked);

        // 장비불러 계정으로 빠른 시작 (구 악덕알리미 앱에서만 그려진다) · 소셜 로그인
        $('#b-login-jb').on('click', () => $j.F.App.jbLogin('BD'));
        $('[data-sns]').on('click', function (e) { e.preventDefault(); $j.F.Social.login(this.dataset.sns); });

        $(function () {
            initTogglePassword();
            initializeInputIcons();
            initLoginFormHandler();
            initLoginFormValidator();
        });

        /**
         * 비밀번호 보이기 토글
         * @param passwordType 비밀번호 타입
         * @param iconType 눈모양 아이콘
         */
        function initTogglePassword() {
            function togglePassword(passwordType, iconType) {
                const input = $(passwordType);
                const icon = $(iconType).find('img');
                const type = $(passwordType).attr('type') === 'password' ? 'text' : 'password';
                input.attr('type', type);
                icon.attr('src', type === 'password' ? '/img/mercury/screet-icon.svg' : '/img/mercury/screetx-icon.svg');
            }

            $('#togglePassword').click(function () {
                togglePassword('#userPassword', this);
            });
        }

        /**
         * 로그인폼 validator 초기화
         */
        function initLoginFormValidator() {
            // FORM VALIDATOR 설정
            $('#loginform').validate({
                rules: {
                    mem_id: {
                        required: true,
                        minlength: 4,
                    },
                    mem_pwd: {
                        required: true,
                        minlength: 4,
                    }
                },
                messages: {
                    mem_id: {
                        required: "아이디를 입력해 주세요.",
                        minlength: "아이디는 최소 4자 이상이어야 합니다.",
                    },
                    mem_pwd: {
                        required: "비밀번호를 입력해 주세요.",
                        minlength: "비밀번호는 최소 4자 이상이어야 합니다.",
                    }
                },
                errorPlacement: function (error, element) {
                    // 현재 포커스된 인풋에만 오류 메시지 표시
                    if ($(element).is(':focus')) {
                        error.insertAfter(element.parent());
                    } else {
                        error.hide();
                    }
                },
                submitHandler: function (form) {
                    const url =`/m/ajax/login`;
                    const $form = $(form);
                    $.ajax({
                        type: 'POST',
                        url: url,
                        data : $form.serialize(),
                        success: function(data){
                            // console.log(data);return;
                            if( data.message ){
                                $j.Common.Util.swalert(data.message);
                                return;
                            }
                            location.href=data.url;
                        }
                    });
                }
            });
        }

        /**
         * 폰번호 스타일 아이디 대시 포맷 (전역 phoneNumber()와 달리 뒷자리 절삭 없음)
         * 예: "0103773620401" -> "010-3773-620401"
         */
        function formatMemIdPhone(value) {
            if (!value) return "";
            value = value.replace(/[^0-9]/g, "");
            var head = value.substring(0, 3);
            var rest = value.substring(3);
            var parts = [head];
            if (rest.length === 7) {
                parts.push(rest.substring(0, 3));
                parts.push(rest.substring(3));
            } else {
                parts.push(rest.substring(0, 4));
                parts.push(rest.substring(4));
            }
            return parts.filter(function (v) { return v; }).join("-");
        }

        /**
         * inputform이 keyup 됐을 때 유효성 검사 실시 후 버튼 속성 변경
         */
        function initLoginFormHandler() {
            $('#loginform').bind('change keyup input', function (e) {
                // 폰번호 아이디인경우 자동 대시 처리
                // 아이디는 폰번호보다 뒷자리가 길 수 있어(예: 010-3773-620401)
                // 전역 phoneNumber()의 8자리 절삭 대신 초과분을 보존해 포맷한다.
                if (e.target.id == 'mem_id') {
                    const $el = $(e.target);
                    if ($el.val().startsWith('01')) {
                        $el.val(formatMemIdPhone($el.val()));
                    }
                }

                $('#loginform').valid({});
            });


        }

        /**
         * 인풋박스에 입력값이 있다면 활성화 아이콘으로 변경
         * @param input 인풋박스 입력값 유무
         */
        function inputIconClass(input) {
            const icon = $(input).closest('.login-page__input-wrapper').find('.login-page__icon');
            if ($(input).val()) {
                icon.addClass('active');
            } else {
                icon.removeClass('active');
            }
        }

        /**
         * 모든 인풋 필드 초기화 및 이벤트 처리
         */
        function initializeInputIcons() {
            // 모든 인풋 필드에 대해 초기화
            $('.login-page__input').each(function () {
                inputIconClass(this);
            });

            // input 이벤트 처리
            $('.login-page__input').on('input', function () {
                inputIconClass(this);
            });
        }
    }
}
